<button class="mb-2 mr-2 btn custom-btn">
    All Flights
    <span class="badge badge-pill badge-light">{{ totalFlights }} Flights</span>
</button>
<button class="mb-2 mr-2 btn custom-btn">
    Fastest Flights
    <span class="badge badge-pill badge-light">{{ fastestFligtTime }}</span>
</button>
<button class="mb-2 mr-2 btn custom-btn">
    Cheapest Flights
    <span
        class="badge badge-pill badge-light">{{ cheapestFlight?.Price?.TotalDisplayFare | number:'1.0-0' }}</span>
</button>